

export default function ErrorNotFound() {
	
	return (
		<>
			<h2>404 Error</h2>
		</>
	);
}